module.exports = __webpack_public_path__ + "img/1644.590cb28b.gif";